import type { TRuleWithTheme } from '@/styles/theme';

export const crypted: TRuleWithTheme = ({ theme }) => ({
    ...theme.typography.Password,
    lineHeight: '1rem',
});
